import React, { useMemo } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as Styles from '../MobileSettingsPanel.styles';
import { useTranslation } from 'react-i18next';

export const SettingsTabs = ({ tabs, update, loading, initialTab }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(initialTab);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Styles.AccordionContainer>
        {tabs.map((item, index) => {
          const { Component } = item;
          return (
            <Accordion
              expanded={item.id ? expanded == item.id : expanded === `panel${index + 1}`}
              onChange={handleChange(item.id || `panel${index + 1}`)}
              key={index}
              sx={{
                background: '#f8f8f8',
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                <Typography
                  sx={(theme) => ({
                    fontSize: theme.typography.pxToRem(15),
                    flexShrink: 0,
                    fontWeight: 900,
                    fontFamily: 'Open Sans',
                  })}
                >
                  {t(item.title_lang)}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                {item.Component ? useMemo(() => <Component loading={loading} />, update) : null}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Styles.AccordionContainer>
    </Box>
  );
};
